export const en = {
  Aanhef: "Title",
  ContactFormulier: "Contact",
  ContactFormulierTitel: "Contactform",
  Mevr: "Mrs.",
  Dhr: "Mr.",
  UwAanvraagIsVerstuurd: "Uw aanvraag is verstuurd.",
  EmailAdres: "Email address",
  EmailValidationDefaultMessage: `The field '{{label}}' was not filled in correctly, for example: name@domain.nl (replace with your own email address).`,
  ErrorFormSubmit: "Submitting of the form has failed: {{errorMessage}}",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "We aim to answer your message within 5 working days. If we have any questions, we will call you with an anonymous phone number. Or we will send you an e-mail.",
  MinimumBedragInfoTxt:
    "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
  NaarOnzeHomepage: "Go to our homepage",
  Omschrijving: "Omschrijving",
  VerplichtVeldIsNietIngevuldTijdensVerzenden: "Verplicht veld is niet ingevuld tijdens verzenden",
  VulUwGegevensIn: "Vul uw gegevens in",
  Voorletters: "Initials",
  Achternaam: "Surname",
  Telefoonnummer: "Telefoonnummer",
  TerugNaarHetFormulier: "Back to the form",
  Verzenden: "Send",
  Vorige: "Previous",
  Volgende: "Next",
  Vraag: "Question",
  BedanktTekst:  "Thank you for your message. Your message has reference number: {{kenmerk}}",
};
